export const SET_ADMIN_NOTIFICATIONS = 'SET_ADMIN_NOTIFICATIONS';
export const CLEAR_ADMIN_NOTIFICATIONS = 'CLEAR_ADMIN_NOTIFICATIONS';

export const clearAdminNotifications = {
  type: CLEAR_ADMIN_NOTIFICATIONS,
}

export const setAdminNotifications = (data) => {
  return {
    type: SET_ADMIN_NOTIFICATIONS,
    payload: data,
  }
}